/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateUpdateInterpretationNormDto } from './CreateUpdateInterpretationNormDto';
import {
    CreateUpdateInterpretationNormDtoFromJSON,
    CreateUpdateInterpretationNormDtoFromJSONTyped,
    CreateUpdateInterpretationNormDtoToJSON,
} from './CreateUpdateInterpretationNormDto';
import type { CreateUpdatePositionNormDto } from './CreateUpdatePositionNormDto';
import {
    CreateUpdatePositionNormDtoFromJSON,
    CreateUpdatePositionNormDtoFromJSONTyped,
    CreateUpdatePositionNormDtoToJSON,
} from './CreateUpdatePositionNormDto';

/**
 * 
 * @export
 * @interface CreateUpdateNormWithValuesDto
 */
export interface CreateUpdateNormWithValuesDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateNormWithValuesDto
     */
    probability?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    group?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateNormWithValuesDto
     */
    examinedCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateNormWithValuesDto
     */
    isDefault?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    printText?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    keyTestName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    indicatorTestName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateNormWithValuesDto
     */
    indicatorTestMode?: string | null;
    /**
     * 
     * @type {Array<CreateUpdatePositionNormDto>}
     * @memberof CreateUpdateNormWithValuesDto
     */
    positionNorms?: Array<CreateUpdatePositionNormDto> | null;
    /**
     * 
     * @type {Array<CreateUpdateInterpretationNormDto>}
     * @memberof CreateUpdateNormWithValuesDto
     */
    interpretationNorms?: Array<CreateUpdateInterpretationNormDto> | null;
}

/**
 * Check if a given object implements the CreateUpdateNormWithValuesDto interface.
 */
export function instanceOfCreateUpdateNormWithValuesDto(value: object): value is CreateUpdateNormWithValuesDto {
    return true;
}

export function CreateUpdateNormWithValuesDtoFromJSON(json: any): CreateUpdateNormWithValuesDto {
    return CreateUpdateNormWithValuesDtoFromJSONTyped(json, false);
}

export function CreateUpdateNormWithValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateNormWithValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'probability': json['probability'] == null ? undefined : json['probability'],
        'group': json['group'] == null ? undefined : json['group'],
        'examinedCount': json['examinedCount'] == null ? undefined : json['examinedCount'],
        'description': json['description'] == null ? undefined : json['description'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'printText': json['printText'] == null ? undefined : json['printText'],
        'keyTestName': json['keyTestName'] == null ? undefined : json['keyTestName'],
        'indicatorTestName': json['indicatorTestName'] == null ? undefined : json['indicatorTestName'],
        'indicatorTestMode': json['indicatorTestMode'] == null ? undefined : json['indicatorTestMode'],
        'positionNorms': json['positionNorms'] == null ? undefined : ((json['positionNorms'] as Array<any>).map(CreateUpdatePositionNormDtoFromJSON)),
        'interpretationNorms': json['interpretationNorms'] == null ? undefined : ((json['interpretationNorms'] as Array<any>).map(CreateUpdateInterpretationNormDtoFromJSON)),
    };
}

export function CreateUpdateNormWithValuesDtoToJSON(value?: CreateUpdateNormWithValuesDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'probability': value['probability'],
        'group': value['group'],
        'examinedCount': value['examinedCount'],
        'description': value['description'],
        'isDefault': value['isDefault'],
        'printText': value['printText'],
        'keyTestName': value['keyTestName'],
        'indicatorTestName': value['indicatorTestName'],
        'indicatorTestMode': value['indicatorTestMode'],
        'positionNorms': value['positionNorms'] == null ? undefined : ((value['positionNorms'] as Array<any>).map(CreateUpdatePositionNormDtoToJSON)),
        'interpretationNorms': value['interpretationNorms'] == null ? undefined : ((value['interpretationNorms'] as Array<any>).map(CreateUpdateInterpretationNormDtoToJSON)),
    };
}

